export function getAlertMessages(alerts, type) {
  const seen = new Set();
  return alerts.reduce((messages, alert) => {
    const mismatchedType = Array.isArray(type) ? !type.includes(alert?.type) : alert?.type !== type;
    if (!alert || (type && mismatchedType))
      return messages;

    const message = alert.message || alert.type;
    if (!message || seen.has(message))
      return messages;

    seen.add(message);
    messages.push(message);
    return messages;
  }, []);
}

export function getJobNameTooltipMessages(alerts, extra) {
  const messages = getAlertMessages(alerts);
  if (extra)
    messages.push(extra.replaceAll('@@', ' / '));
  return messages;
}

const focusedAlertExcludedFields = new Set(['__check__', 'url', 'action']);

export function getFocusedAlertMessages(focusedCell, alertsByJob) {
  if (!focusedCell || focusedAlertExcludedFields.has(focusedCell.field))
    return [];
  return getAlertMessages(alertsByJob?.[focusedCell.id] || []);
}
